.alerts {
    display: flex;
    flex-direction: column;
}
